module.exports = __webpack_public_path__ + "img/gameTronos3.5127a4ca.jpg";